import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Episode extends Component {

	openUrl = (e) => {
		e.preventDefault();
		if (this.props.episodeUrl) {
			window.open(this.props.episodeUrl, '_blank', 'noopener,noreferrer');
		}
	};

	render() {
		// Episode name starts with its number, e.g. "12 Some title".
		const episodeNumber = (this.props.name || '').split(' ')[0];
		return (
			<Link to={"/episodes/" + this.props.id}
				className="bg-surface-container border border-outline-variant rounded flex flex-col overflow-hidden hover:border-primary-container transition-colors group">
				<div className="relative h-48 w-full bg-surface-variant overflow-hidden">
					<img alt={this.props.name}
						className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
						src={this.props.imageUrl} />
					<div className="absolute top-3 left-3 bg-primary-container text-on-primary font-label-sm text-label-sm px-2 py-1 rounded">{episodeNumber}</div>
				</div>
				<div className="p-4 flex flex-col flex-1 gap-2">
					<h3 className="font-headline-lg-mobile text-headline-lg-mobile text-on-surface line-clamp-2 leading-tight">{this.props.name}</h3>
					<p className="font-body-md text-body-md text-on-surface-variant text-sm line-clamp-3">{this.props.description}</p>
					<div className="mt-auto pt-4 flex gap-2 border-t border-outline-variant">
						<button onClick={this.openUrl} className="text-on-surface-variant hover:text-secondary transition-colors p-1" aria-label="Play">
							<span className="material-symbols-outlined text-lg">play_circle</span>
						</button>
						<button onClick={this.openUrl} className="text-on-surface-variant hover:text-secondary transition-colors p-1" aria-label="Listen">
							<span className="material-symbols-outlined text-lg">headphones</span>
						</button>
					</div>
				</div>
			</Link>
		);
	}

}
export default Episode;
